'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'jet-fighter';
var width = 640;
var height = 512;
var aliases = ["fighter-jet"];
var unicode = 'f0fb';
var svgPathData = 'M208 16l36 0L368.1 184 208 184l0-168zM384.1 200L485 200c6.3 0 12.7 1.1 18.6 3.2l110.6 39c5.8 2.1 9.8 7.6 9.8 13.8s-3.9 11.7-9.8 13.8l-110.6 39c-6 2.1-12.3 3.2-18.6 3.2l-100.9 0-.2 0L152 312c-1.9 0-3.7 .7-5.1 1.9l-39.1 32.6C103.5 350 98 352 92.4 352L72 352c-13.3 0-24-10.7-24-24l0-64 104 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L48 248l0-64c0-13.3 10.7-24 24-24l20.4 0c5.6 0 11.1 2 15.4 5.6l39.1 32.6c1.4 1.2 3.3 1.9 5.1 1.9l231.9 0 .2 0zM32 264l0 64c0 22.1 17.9 40 40 40l20.4 0c9.4 0 18.4-3.3 25.6-9.3L154.9 328l37.1 0 0 168c-4.4 0-8 3.6-8 8s3.6 8 8 8l8 0 47.9 0 .2 0 55.9 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-40.1 0L388 328l97 0c8.2 0 16.3-1.4 24-4.1l110.6-39C631.8 280.5 640 269 640 256s-8.2-24.5-20.4-28.9L509 188.1c-7.7-2.7-15.8-4.1-24-4.1l-97 0L263.9 16 304 16c4.4 0 8-3.6 8-8s-3.6-8-8-8L248.1 0l-.2 0L200 0l-8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l0 168-37.1 0L118 153.3c-7.2-6-16.2-9.3-25.6-9.3L72 144c-22.1 0-40 17.9-40 40l0 64L8 248c-4.4 0-8 3.6-8 8s3.6 8 8 8l24 0zm176 64l160.1 0L244 496l-36 0 0-168z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faJetFighter = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;